module.exports = __webpack_public_path__ + "static/bg-red1-212d13161b9e4a3a0c76d05fe4a953fa.jpg";